import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useLoginMutation } from './Api';
import { decryption, encryption } from '../CryptoJs/Crypto'
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useUserAccess } from '../Context/UserAccessContext';
const authMode = process.env.REACT_APP_AUTH_MODE;
const Login = () => {

    const navigate = useNavigate()

    const [password, setPassword] = useState(true);
    const passwordChangeIcon = password === true ? false : true;

    const [loginApi, { isLoading }] = useLoginMutation()

    const { setUserAccess } = useUserAccess();

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required('Email is required')
            .matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                "Enter valid email")
            .email('Email is invalid')
            .trim(),
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
            )
            .trim(),
        rememberMe: Yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    useEffect(() => {
        const email = Cookies.get("liame");
        const password = Cookies.get("drowssap");

        if (email && password) {
            reset({
                email: decryption(email),
                password: decryption(password),
                rememberMe: true
            })
        }
    }, []);

    // dark mode
    useEffect(() => {
        const theme = localStorage.getItem('theme')
        if (theme === 'dark') {
            const darkMode = true
            document.documentElement.classList.toggle("app-skin-dark", darkMode);
        }
    }, []);

    const onSubmit = async (data) => {
        try {

            const payload = {
                email: data.email,
                password: data.password
            }

            const loginApiResponse = await loginApi(payload)
            // console.log(loginApiResponse, 'loginApiResponse')

            if (loginApiResponse?.data?.success) {
                const userData = loginApiResponse.data.data;
                // localStorage.setItem("token", loginApiResponse.data.data.token)
                console.log("🚀 ~ onSubmit ~ authMode:", authMode)
                if (authMode === "bearer") {
                    localStorage.setItem(
                        "token",
                        userData.token
                    );
                }
                localStorage.setItem("isLoggedIn", "true")

                // localStorage.setItem("access", loginApiResponse.data.data.access)
                localStorage.setItem("access", JSON.stringify(userData.access || []));
                localStorage.setItem("role", String(userData.role));
                setUserAccess(userData.access || []);

                localStorage.setItem(
                    "user",
                    JSON.stringify({
                        name: userData.name,
                        email: userData.email,
                        role: userData.role
                    })
                );

                if (data.rememberMe) {
                    const encrptEmail = encryption(data.email)
                    const encryptPass = encryption(data.password)

                    Cookies.set("liame", encrptEmail, { expires: 7 });
                    Cookies.set("drowssap", encryptPass, { expires: 7 });
                } else {
                    Cookies.remove("liame");
                    Cookies.remove("drowssap");
                }

                ToastrService.success(loginApiResponse.data.message);
                reset()
                navigate('/dashboard')

            } else {
                ToastrService.error(loginApiResponse?.error?.data?.message);
            }
        } catch (err) {
            console.log(err, 'err')
        }

    };

    return (
        <div>
            {isLoading ? <Loader /> :
                <div className="auth-minimal-wrapper">
                    <div className="auth-minimal-inner">
                        <div className="minimal-card-wrapper">
                            <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
                                <div class="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
                                    <img src='images/logo/logoicon.ico' alt="" class="img-fluid" />
                                </div>
                                <div className="card-body p-sm-5">
                                    <h2 className="fs-20 fw-bolder mb-4">Login</h2>

                                    <form onSubmit={handleSubmit(onSubmit)} className="w-100 mt-4 pt-2">
                                        <div className="mb-4">
                                            <input
                                                type="text"
                                                id="mail"
                                                name='email'
                                                placeholder='Email'
                                                {...register('email')}
                                                className="form-control"
                                            />
                                            {errors.email && (
                                                <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.email.message}
                                                </p>
                                            )}
                                        </div>
                                        {/* <div className="mb-3 password-wrapper">
                                            <input
                                                type={passwordChangeIcon ? "text" : "password"}
                                                id="mail"
                                                name='password'
                                                placeholder='Password'
                                                {...register('password')}
                                                className="form-control"

                                            />
                                         {errors.password && (
                                            <p style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                {errors.password.message}
                                            </p>
                                        )}
                                        </div>
                                         */}
                                        <div className="mb-3">
                                            <div className="password-field">
                                                <input
                                                    type={passwordChangeIcon ? "text" : "password"}
                                                    {...register("password")}
                                                    className="form-control"
                                                    placeholder="Password"
                                                />
                                                <span
                                                    className="password-icon"
                                                    onClick={() => setPassword(!password)}
                                                >
                                                    {passwordChangeIcon ? <FaEye /> : <FaEyeSlash />}
                                                </span>
                                            </div>
                                            {errors.password && (
                                                <p className='mt-2' style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                    {errors.password.message}
                                                </p>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                            {/* <div>
                                                <div className="form-check">
                                                    <input type="checkbox" className="form-check-input" id="rememberMe" {...register('rememberMe')} />
                                                    <label className="form-check-label c-pointer" htmlFor="rememberMe">
                                                        Remember Me
                                                    </label>
                                                </div>
                                            </div> */}
                                            <div className="remember-wrapper">
                                                <input
                                                    type="checkbox"
                                                    id="rememberMe"
                                                    className="remember-checkbox"
                                                    {...register("rememberMe")}
                                                />
                                                <label htmlFor="rememberMe" className="remember-label">
                                                    Remember Me
                                                </label>
                                            </div>
                                            <div>
                                                <a onClick={() => navigate("/forgotPassword")} className="fs-11 text-primary" style={{ cursor: 'pointer' }}>
                                                    Forgot password?
                                                </a>
                                            </div>
                                        </div>
                                        <div className="mt-5">
                                            <button type="submit" className="btn btn-lg btn-primary w-100">
                                                Login
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Login